import { reactive } from 'vue';

export const toasts = reactive([]);

let toastId = 0;

export function toast(message, { tone = 'default', timeout = 2800, action = null } = {}) {
  const id = ++toastId;
  toasts.push({ id, message, tone, action });
  setTimeout(() => dismissToast(id), timeout);
  return id;
}

export function dismissToast(id) {
  const i = toasts.findIndex((t) => t.id === id);
  if (i !== -1) toasts.splice(i, 1);
}

export const confirmState = reactive({ open: false, title: '', message: '', details: [], input: null, actions: [], resolve: null });

export function choose({ title, message = '', details = [], input = null, actions }) {
  return new Promise((resolve) => {
    if (confirmState.resolve) confirmState.resolve(null);
    Object.assign(confirmState, { open: true, title, message, details, input, actions, resolve });
  });
}

export async function confirm({ title, message = '', details = [], confirmLabel = 'Confirm', danger = false }) {
  const result = await choose({
    title,
    message,
    details,
    actions: [
      { value: false, label: 'Cancel', variant: 'ghost' },
      { value: true, label: confirmLabel, variant: danger ? 'danger' : 'primary' }
    ]
  });
  return result === true;
}

/** Ask for a short piece of text. Resolves to the text, or null when cancelled. */
export async function prompt({ title, message = '', label = '', value = '', placeholder = '', confirmLabel = 'Save' }) {
  const input = reactive({ label, value, placeholder });
  const result = await choose({
    title,
    message,
    input,
    actions: [
      { value: false, label: 'Cancel', variant: 'ghost' },
      { value: true, label: confirmLabel, variant: 'primary', submit: true }
    ]
  });
  return result === true ? input.value : null;
}

export function settleConfirm(value) {
  const resolve = confirmState.resolve;
  Object.assign(confirmState, { open: false, resolve: null });
  resolve?.(value);
}
